import api from '../api';
import { CarResponse, IFilterVariables, IVehicleFilters, IOrder } from '../models';

export class FleetsService {
  public list = (params?: IVehicleFilters) => {
    if (params) {
      const filters = new URLSearchParams(params as any);
      return api.get<CarResponse[]>(`/pwa/vehicle?${filters}`);
    }
    return api.get<CarResponse[]>('/pwa/vehicle');
  };

  public listById = (id: string) => api.get(`/pwa/vehicle/${id}`);

  public filterVariables = () =>
    api.get<IFilterVariables>(`/pwa/vehicle/filter-variables`);

  public createOrder = (data: IOrder) => api.post(`/pwa/vehicle-order`, data);

  public listOrder = () => api.get(`/pwa/vehicle-order/my-orders`)

  public updateOrder = (data: IOrder, orderId: number) => api.put(`/pwa/vehicle-order/${orderId}`, data)

  public cancelOrder = (orderId: number) => api.put(`/pwa/vehicle-order/${orderId}/cancel`)

  public removeVehicle = (orderId: number, vehicleId:number) => api.delete(`/pwa/vehicle-order/${orderId}/remove/${vehicleId}`)

  public endDate = () => api.get(`/pwa/batch/current`);

  public period = () => api.get(`/pwa/batch/period`);
}

const buildingService = new FleetsService();
export default buildingService;
